import { Checkbox, FormControlLabel } from '@mui/material';
import { TextSpan } from '../../../Atoms/Text';
import { dollars } from './currentSupplierSpend';

export interface InvoiceTaxesToggleProps {
  taxes: number;
  included: boolean;
  canEdit: boolean;
  onChange: (included: boolean) => void;
}

/** Whether the supplier's baseline adds its most recent invoice's taxes and surcharges, shown beside the choice. */
export const InvoiceTaxesToggle = ({ taxes, included, canEdit, onChange }: InvoiceTaxesToggleProps) => (
  <div className="flex items-center gap-2">
    <FormControlLabel
      className="m-0"
      control={
        <Checkbox
          size="small"
          checked={included}
          disabled={!canEdit}
          onChange={(event) => onChange(event.target.checked)}
        />
      }
      label={
        <TextSpan
          size="sm"
          weight="medium"
          color="grey8">
          Include taxes &amp; surcharges in baseline
        </TextSpan>
      }
    />
    <TextSpan
      size="xs"
      color="grey6">
      {`${dollars(taxes)} /mo — excluded by default`}
    </TextSpan>
  </div>
);
